import { render, staticRenderFns } from "./dummy-links.vue?vue&type=template&id=9b77c50a&scoped=true&"
import script from "./dummy-links.vue?vue&type=script&lang=js&"
export * from "./dummy-links.vue?vue&type=script&lang=js&"
import style0 from "./dummy-links.vue?vue&type=style&index=0&id=9b77c50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b77c50a",
  null
  
)

export default component.exports